
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/r/[slug]",
      function () {
        return require("private-next-pages/sitemap/r/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/r/[slug]"])
      });
    }
  